import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const AUTOMATION_PANEL_NAME = 'automationPanel';

export interface AutomationPanelData {
  mode?: string;
  catalog?: any;
  automationToUpdate?: any;
}

@Injectable({ providedIn: 'root' })
export class AutomationPanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  private _data: AutomationPanelData | null = null;

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(data?: AutomationPanelData): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();
    this._data = data ?? null;

    this._isOpen$.next(true);
    setTimeout(() => {
      const sidebar = this._fuseSidebarService.getSidebar(
        AUTOMATION_PANEL_NAME,
      );
      sidebar?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  getData(): AutomationPanelData | null {
    return this._data;
  }

  emitResult(result: any | false): void {
    const sidebar = this._fuseSidebarService.getSidebar(
      AUTOMATION_PANEL_NAME,
    );
    sidebar?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._data = null;
    this._isOpen$.next(false);
  }
}
